import StreamSaver from 'streamsaver';

StreamSaver.mitm = `${window.location.origin}/stream_saver_mitm.html?version=1`;

export default StreamSaver;
